import type { Disposable, Model } from '@patsnap/tahiti-core';
import type { NoveltyCheckStepInfo, NoveltyCheckStepInfoStatus } from '../types';
import type { NoveltyCheckTaskStep } from '../enums';

/**
 * 查新步骤信息状态
 * @description 存储查新任务进行步骤中产生的状态数据
 */
export interface NoveltyCheckStepInfoState {
    /**
     * 步骤信息映射
     * @description 以步骤为键，存储每个步骤的状态信息
     */
    stepsInfo: Record<NoveltyCheckTaskStep, NoveltyCheckStepInfo>;
}

/**
 * 查新步骤信息模型
 * @description 存储查新任务进行步骤中产生的状态数据
 */
export interface NoveltyCheckStepInfoModel extends Model<NoveltyCheckStepInfoState>, Disposable {
    /**
     * 设置步骤状态
     * @param step 步骤
     * @param status 状态
     */
    setStepStatus(step: NoveltyCheckTaskStep, status: NoveltyCheckStepInfoStatus): void;

    /**
     * 获取步骤花费的时间
     * @param step 步骤
     * @returns 花费的总时间（毫秒）
     */
    getStepSpendTime(step: NoveltyCheckTaskStep): number;

    /**
     * 获取步骤信息
     * @param step 步骤
     * @returns 步骤信息
     */
    getStepInfo(step: NoveltyCheckTaskStep): NoveltyCheckStepInfo;

    /**
     * 检查步骤是否完成
     * @param step 步骤
     * @returns 是否完成
     */
    isStepCompleted(step: NoveltyCheckTaskStep): boolean;

    /**
     * 检查步骤是否被锁定
     * @param step 步骤
     * @returns 是否被锁定
     */
    isStepLocked(step: NoveltyCheckTaskStep): boolean;

    /**
     * 检查步骤是否处于待确认状态
     * @param step 步骤
     * @returns 是否处于待确认状态
     */
    isStepWaitingForConfirmation(step: NoveltyCheckTaskStep): boolean;

    /**
     * 检查步骤是否正在进入
     * @param step 步骤
     * @returns 是否正在进入
     */
    isStepEntering(step: NoveltyCheckTaskStep): boolean;

    /**
     * 检查步骤是否处于错误状态
     * @param step 步骤
     * @returns 是否处于错误状态
     */
    isStepError(step: NoveltyCheckTaskStep): boolean;

    /**
     * 重置指定步骤
     * @param step 步骤
     * @description 将指定步骤恢复为创建前的样子，即删除其相关的info
     */
    resetStep(step: NoveltyCheckTaskStep): void;
}

export const NoveltyCheckStepInfoModel = Symbol.for('NoveltyCheckStepInfoModel');
